var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSixSenseLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 512,
    height: 512,
    viewBox: "0 0 512 512",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138.787 438.604L194.329 374.378C182.936 355.622 179.518 331.75 188.348 309.584C200.026 279.46 229.364 261.841 261.55 263.83C269.811 264.399 277.786 266.388 285.192 269.514L341.019 205.004C324.784 194.773 306.554 187.385 288.04 183.69C307.978 159.535 379.757 76.8369 379.757 76.8369L316.239 20C316.239 20 220.534 133.39 188.348 172.891C169.264 196.479 149.895 220.066 130.811 243.653C106.316 273.777 96.3463 317.825 101.189 356.474C105.461 388.019 119.133 416.153 138.787 438.604Z",
    fill: "#00B3B0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M399.413 272.356C392.862 256.442 382.893 241.664 370.645 229.16L315.387 293.102C326.496 307.879 332.192 326.92 329.344 346.244C323.932 384.609 285.764 416.154 246.172 408.765C237.342 407.628 229.367 404.786 221.961 400.808L167.273 463.897C202.877 488.621 248.166 499.135 293.17 488.336C386.881 465.602 439.005 360.454 399.413 272.356Z",
    fill: "#040205"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSixSenseLogo);
export default __webpack_public_path__ + "static/media/six-sense-logo.2eb4aa122bff0e8dc80b4c4102fd9485.svg";
export { ForwardRef as ReactComponent };